import { Link } from "react-router-dom";

export default function BlogPreview() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Latest GTBuy Guides
          </h2>
          <p className="text-foreground-500 text-sm max-w-md mx-auto">
            Learn how to maximize your savings with spreadsheet-based product comparison
          </p>
        </div>

        <div className="flex gap-6 overflow-x-auto pb-4 -mx-4 px-4 snap-x snap-mandatory">
          <Link
            to="/article/gtbuy-spreadsheet-complete-guide"
            className="flex-shrink-0 w-[280px] md:w-[320px] snap-start group cursor-pointer"
          >
            <div className="bg-white rounded-2xl overflow-hidden">
              <div className="relative h-[200px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20workspace%20flatlay%20with%20laptop%20showing%20spreadsheet%20data%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20white%20desk%2C%20editorial%20tech%20lifestyle%20photography%2C%20modern%20cozy%20home%20office%2C%20gentle%20morning%20atmosphere&width=640&height=480&seq=blog-card-01&orientation=landscape"
                  alt="GTBuy Spreadsheet Complete Guide"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-semibold bg-primary-500 text-white">
                  New
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>July 2026</span>
                  <span>·</span>
                  <span>8 min read</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  GTBuy Spreadsheet: The Complete Guide to Smart Product Comparison in 2026
                </h3>
                <p className="text-sm text-foreground-500 mt-2 line-clamp-2">
                  Discover how the GTBuy Spreadsheet system transforms online shopping with data-driven price comparisons across multiple platforms.
                </p>
              </div>
            </div>
          </Link>

          <Link
            to="/article/gtbuy-spreadsheet-complete-guide"
            className="flex-shrink-0 w-[280px] md:w-[320px] snap-start group cursor-pointer"
          >
            <div className="bg-white rounded-2xl overflow-hidden">
              <div className="relative h-[200px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20setup%20with%20multiple%20screens%20displaying%20comparison%20charts%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20interior%2C%20clean%20workspace%20aesthetic%2C%20editorial%20productivity%20photography%2C%20cozy%20home%20office%20vibe%2C%20gentle%20morning%20sunlight&width=640&height=480&seq=blog-card-02&orientation=landscape"
                  alt="GTBuy Spreadsheet vs Kakobuy vs Superbuy"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>July 2026</span>
                  <span>·</span>
                  <span>6 min read</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  GTBuy vs Kakobuy vs Superbuy: Which Spreadsheet Is Best for You?
                </h3>
                <p className="text-sm text-foreground-500 mt-2 line-clamp-2">
                  A detailed comparison of the three major spreadsheet shopping tools and how to choose the right one for your needs.
                </p>
              </div>
            </div>
          </Link>

          <Link
            to="/article/gtbuy-spreadsheet-complete-guide"
            className="flex-shrink-0 w-[280px] md:w-[320px] snap-start group cursor-pointer"
          >
            <div className="bg-white rounded-2xl overflow-hidden">
              <div className="relative h-[200px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20product%20comparison%20flatlay%20with%20smartphone%20showing%20shopping%20app%2C%20surrounded%20by%20fashion%20items%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20lifestyle%20photography%2C%20clean%20minimal%20composition%2C%20bright%20airy%20atmosphere&width=640&height=480&seq=blog-card-03&orientation=landscape"
                  alt="Best Spreadsheet for Product Comparison 2026"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>June 2026</span>
                  <span>·</span>
                  <span>5 min read</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  Best Spreadsheet for Product Comparison: 2026 Ultimate Guide
                </h3>
                <p className="text-sm text-foreground-500 mt-2 line-clamp-2">
                  Why spreadsheet-based comparison beats traditional review sites every time. Data-driven shopping explained.
                </p>
              </div>
            </div>
          </Link>

          <Link
            to="/article/gtbuy-spreadsheet-complete-guide"
            className="flex-shrink-0 w-[280px] md:w-[320px] snap-start group cursor-pointer"
          >
            <div className="bg-white rounded-2xl overflow-hidden">
              <div className="relative h-[200px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20home%20office%20with%20tablet%20displaying%20price%20tracking%20data%2C%20soft%20natural%20daylight%20from%20window%2C%20warm%20beige%20and%20cream%20interior%2C%20editorial%20tech%20lifestyle%20photography%2C%20clean%20minimalist%20workspace%2C%20cozy%20productive%20atmosphere&width=640&height=480&seq=blog-card-04&orientation=landscape"
                  alt="Real-time Product Comparison Spreadsheet"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>June 2026</span>
                  <span>·</span>
                  <span>7 min read</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  Real-Time Product Comparison: How GTBuy Spreadsheet Keeps You Ahead
                </h3>
                <p className="text-sm text-foreground-500 mt-2 line-clamp-2">
                  How real-time data updates give GTBuy Spreadsheet users an edge in finding the best deals before they disappear.
                </p>
              </div>
            </div>
          </Link>
        </div>

        <div className="text-center mt-10">
          <Link
            to="/article/gtbuy-spreadsheet-complete-guide"
            className="inline-flex items-center px-6 py-3 rounded-full text-sm font-semibold border-2 border-foreground-200 text-foreground-800 hover:border-foreground-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Guides
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}